import resume from "../assets/pdf/Frontend-Eng.pdf";
// import { pro_pic } from "./pro_pic";

export const headerData = {
  name: "Bhaskar Kumar",
  smallIntro: "I'm Bhaskar Kumar",
  title: [
    "A Frontend Engineer",
    "A React.js Developer",
    "A Next.js Developer",
    "Who loves creating cool stuff",
    "Let's build something together!",
  ],
  desciption:
    "Greetings! A results-driven Frontend Engineer with comprehensive expertise in the JavaScript, TypeScript, React.js, Next.js. With more than three years of professional experience in high-performance web application development. While deliving into backend technologies to broaden exprtise and contribute holistically.",
  image:
    "https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png",
  resumePdf: resume,
};
